import React, { Component } from 'react';
import ArtCard from './ArtCard';
import data from './data';

class GamesList extends Component {

    constructor() {
        super();
        this.state = { categories: data };
        this.renderArtCard = this.renderArtCard.bind(this);
    }

    // Map through games and list a card for each
    renderArtCard(key) {
        return (
            <ArtCard 
                key={key} 
                details={key} 
            />
        )
    }

    render() {
        return(
            <div>
                { data.map(this.renderArtCard) }
            </div>
        );
    }
}

export default GamesList;


// WEBPACK FOOTER //
// ./src/components/ArtList.js